import styled from '@emotion/styled'

export const ErrorBullets = styled.li`
	font-size: 16px;
	list-style-type: disc;
	list-style-position: inside;
	color: red;
	text-indent: -24px;
	padding-left: 32px;

	a {
		font-weight: 800;
		color: red;
	}
`
